import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { token } from 'utils';
import { getSocket } from 'utils/socketManager';
import { sessionActions } from '../../store';

export const useSessionSocket = (sessionId) => {
    const dispatch = useDispatch();
    const socketRef = useRef(null);
    const joinedRef = useRef(false);
    const deviceId = localStorage.getItem('deviceId');

    useEffect(() => {
        if (!token() || !sessionId) return;

        let cancelled = false;
        const socket = getSocket(token(), deviceId);
        socketRef.current = socket;

        const join = () => {
            if (joinedRef.current) return;
            socket.emit('session:join', { sessionIds: [sessionId] });
            joinedRef.current = true;
        };

        const handleUpdate = (data) => {
            if (cancelled) return;
            if (data?.sessionId === sessionId) {
                dispatch(sessionActions.getSessionById(data.sessionId, 'noLoad'));
            }
        };

        const handleSync = (syncedSessionIds) => {
            if (cancelled) return;
            if (syncedSessionIds?.includes(sessionId)) {
                dispatch(sessionActions.getSessionById(sessionId, 'noLoad'));
            }
        };

        socket.on('connect', join);
        socket.on('update:sessions', handleUpdate);
        socket.on('sync:sessions', handleSync);

        if (socket.connected) {
            join();
        }

        return () => {
            cancelled = true;
            socket.emit('session:leave', { sessionIds: [sessionId] });
            joinedRef.current = false;
            socket.off('connect', join);
            socket.off('update:sessions', handleUpdate);
            socket.off('sync:sessions', handleSync);
        };
    }, [sessionId]);
};
